import React, { useState } from 'react';
import DatabaseConnection from './DatabaseConnection';
import ChatInterface from './ChatInterface';

function CustomerUserHome({ session, onLogout }) {
  const [dbConnection, setDbConnection] = useState(null);
  const [agent, setAgent] = useState(null);

  const getUserDisplayName = (s) => {
    return (
      s?.display_name ||
      s?.profile?.display_name ||
      s?.username ||
      s?.profile?.username ||
      s?.email ||
      s?.profile?.email ||
      'User'
    );
  };

  const handleDatabaseConnect = (connectionData) => {
    setDbConnection(connectionData);
  };

  const handleNewChat = () => {
    setAgent(null);
  };

  const handleBackToConnection = () => {
    setDbConnection(null);
    setAgent(null);
  };

  return (
    <div className="app">
      <header className="dashboard-header" style={{ padding: '1rem 2rem', background: '#fff', boxShadow: '0 2px 4px rgba(0,0,0,0.1)' }}>
        <div>
          <h1
            className="text-green-500"
            style={{ color: '#22c55e', fontSize: '2rem', fontWeight: 700 }}
          >
            Hello {getUserDisplayName(session)}
          </h1>
        </div>
        <button className="outline-button" onClick={onLogout}>
          Logout
        </button>
      </header>

      {!dbConnection ? (
        <DatabaseConnection 
          onConnect={handleDatabaseConnect}
          onBack={onLogout}
          session={session}
        />
      ) : (
        <ChatInterface 
          dbConnection={dbConnection}
          onNewChat={handleNewChat}
          onBack={handleBackToConnection}
          agent={agent}
          setAgent={setAgent}
          session={session}
        />
      )}
    </div>
  );
}

export default CustomerUserHome;

